package com.essntl.features.authentication.ui.auth

import com.essntl.core.utils.viewmodel.State
import com.essntl.features.authentication.domain.models.CheckModel

data class AuthState(
    // Check
    val email: String = "",
    val emailError: String = "",

    // Register
    val firstName: String = "",
    val lastName: String = "",

    // Login
    val otp: String = "",

    // Submit
    val checkSubmit: State<CheckModel> = State(),
    val registerSubmit: State<Unit> = State(),
    val loginSubmit: State<Unit> = State(),

    // Demo otp
    val sendOtpSubmit: State<Unit> = State(),
) {
    val isLoading
        get() = checkSubmit.isLoading ||
            registerSubmit.isLoading ||
            loginSubmit.isLoading
}